import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {

  constructor(
    private api: RestApiService
  ) { }

  askFile() : Promise<any> {
    return new Promise((resolve, reject) => {
      let inputFile = document.createElement('input');

      inputFile.type = 'file';
      inputFile.accept = 'image/*';
      inputFile.addEventListener('change', function () {
        resolve(inputFile.files[0]);
      });
      inputFile.click();
    });
  }

  loadFile(filePath) : Promise<any> {
    return new Promise((resolve, reject) => {
      var result = null;
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.open("GET", filePath, false);
      xmlhttp.send();
      if (xmlhttp.status==200) {
        result = xmlhttp.responseText;
      }
      resolve(result);
    });
  }

  setFile(fileAsByteArray, type) : Promise<any> {
    return new Promise((resolve, reject) => {
      var bytes = new Uint8Array(fileAsByteArray);
      var file = new Blob([bytes], {type: type});

      resolve(file);
    });
  }

  downloadFile(file, fileName) : void {
    FileSaver.saveAs(file, fileName);
  }

  modifyVehiclePhoto(idVehicle : number, photo : any) : Promise<any> {
    return new Promise((resolve, reject) => {
      let formData = new FormData();

      formData.append('id_vehicle', idVehicle.toString());
      formData.append('photo', photo);
      this.api.post("/MI_Galago/WCF_MI_Galago/REST/vop/vehicle/photo/update", formData, false).then((res) => {
        resolve(res);
      });
    });
  }

  modifyStationPhoto(idStation : number, photo : any) : Promise<any> {
    return new Promise((resolve, reject) => {
       let formData = new FormData();

      formData.append('id_station', idStation.toString());
      formData.append('photo', photo);
      this.api.put("/MI_Galago/WCF_MI_Galago/REST/vop/station/photo", formData, false).then((res) => {
        resolve(res);
      });
    });
  }

  modifyUserPhoto(idAccount: number, photo: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let formData = new FormData();

      formData.append('id_account', idAccount.toString());
      formData.append('photo', photo);
      this.api.post("/MI_Galago/WCF_MI_Galago/REST/vop/account/photo/update", formData, false).then((res) => {
        resolve(res);
      });
    });
  }
}
